import React, { useState } from 'react';
import styles from './DynamicTextList.module.css';
import AutoCompleteInput from "./AutoCompleteInput";
import {RiDeleteBin2Line} from "react-icons/ri";
import {MdAdd, MdDelete} from "react-icons/md";



/* ---------- Re-usable dynamic list component ---------- */
export default function DynamicTextList({
                                            value = [],          // Array<string>
                                            onChange,            // (newArray) => void
                                            candidates = [],     // Auto-complete options
                                        }) {
    const addRow  = () => onChange?.([...value, '']);
    const removeRow = idx =>
        onChange?.(value.filter((_, i) => i !== idx));

    const setRow = (idx, newVal) =>
        onChange?.(
            value.map((v, i) => (i === idx ? newVal : v))
        );

    return (
        <div className={styles.container}>
            {value.map((text, idx) => (
                <div key={idx} className={styles.row}>
                    <AutoCompleteInput
                        value={text}
                        onChange={v => setRow(idx, v)}
                        candidates={candidates}
                    />

                    <div className={"fa-icon -smaller"}
                         onClick={() => removeRow(idx)}
                         title={"remover validação"}
                    >
                        <MdDelete />
                    </div>
                    {/*<button*/}
                    {/*    type="button"*/}
                    {/*    // className={"button-alert"}*/}
                    {/*    onClick={() => removeRow(idx)}*/}
                    {/*    aria-label={`Remove row ${idx + 1}`}*/}
                    {/*>*/}
                    {/*    &minus;*/}
                    {/*</button>*/}
                </div>
            ))}

            <div
                className={"fa-icon-with-text"}
                onClick={addRow}
            >
                <MdAdd  />
                <div>Adicionar nova validação</div>
            </div>
        </div>
    );
}
